import { useEffect, useRef, useState } from 'react';

const useAutoHide = ({ autoHide, action, type, delayedMessage, message, title, delay = 3000 }, onAutoHide) => {
  const autoHideTimer = useRef(null);
  const delayedMessageTimer = useRef(null);
  const [showMessage, setShowMessage] = useState(false);

  useEffect(() => {
    if (autoHide && !action && type !== 'error') {
      autoHideTimer.current = setTimeout(() => {
        onAutoHide?.();
      }, delay);
    }

    if (delayedMessage && !autoHide) {
      delayedMessageTimer.current = setTimeout(() => {
        setShowMessage(true);
      }, delay + 2000);
    } else if (message) {
      setShowMessage(true);
    }

    return () => {
      if (autoHideTimer.current) clearTimeout(autoHideTimer.current);
      if (delayedMessageTimer.current) clearTimeout(delayedMessageTimer.current);
    };
    // `title` is tracked so a title-only notification (no `message` body) still
    // re-arms the dismiss timer when it appears — otherwise the effect never
    // re-runs and the toast hangs around until manually closed.
  }, [autoHide, action, type, delayedMessage, message, title, onAutoHide, delay]);

  return { autoHideTimer, delayedMessageTimer, showMessage };
};

export default useAutoHide;
